import React from "react";
import "./ColeccionBodasSection.css";
import boda_fran_laia from "./media/L+F-0699.jpg";
import boda_alvaro_laura from "./media/alvaro_laura.webp";
import boda_xavier_irene from "./media/xavier_irene.webp";
import boda_carlos_claudia from "./media/carlos_claudia.webp";
import boda_manuel_isabale from "./media/DSCF9707.jpg";

export default function ColeccionBodasSection() {
    return (
        <section className="coleccion-bodas-section" id="ColeccionBodasSection">
            <p className="coleccion-bodas-titulo">Colección de bodas</p>
            <div className="coleccion-bodas-grid">
                <div className="grid-item boda-1">
                    <div className="img-container">
                        <img src={boda_fran_laia} alt="Boda Fran & Laia"/>
                    </div>
                    <div className="titulos-section-rigt">
                        <p className="titulo-boda">Boda Fran & Laia</p>
                        <p className="subtitulo-boda">Vilanova del Vallés - 10/2020</p>
                    </div>
                </div>
                <div className="grid-item boda-2">
                    <div className="img-container">
                        <img src={boda_alvaro_laura} alt="Boda Álvaro & Laura"/>
                    </div>
                    <div className="titulos-section-rigt">
                        <p className="titulo-boda">Boda Álvaro & Laura</p>
                        <p className="subtitulo-boda">Alicante - 10/2024</p>
                    </div>
                </div>
                <div className="grid-item boda-3">
                    <div className="img-container">
                        <img src={boda_xavier_irene} alt="Boda Xavier & Irene"/>
                    </div>
                    <div className="titulos-section-rigt">
                        <p className="titulo-boda">Boda Xavier & Irene</p>
                        <p className="subtitulo-boda">Alicante - 12/2023</p>
                    </div>
                </div>
                <div className="grid-item boda-4">
                    <div className="img-container">
                        <img src={boda_carlos_claudia} alt="Boda Carlos & Claudia"/>
                    </div>
                    <div className="titulos-section-left">
                        <p className="titulo-boda">Boda Carlos & Claudia</p>
                        <p className="subtitulo-boda">Alicante - 03/2021</p>
                    </div>
                </div>
                <div className="grid-item boda-5">
                    <div className="img-container">
                        <img src={boda_manuel_isabale} alt="Boda Manuel & Isabel"/>
                    </div>
                    <div className="titulos-section-rigt">
                        <p className="titulo-boda">Boda Manuel & Isabel</p>
                        <p className="subtitulo-boda">Úbeda - 04/2018</p>
                    </div>
                </div>
            </div>
        </section>
    );
}
